import { useState } from 'react';
import { PageContainer, PageIntroCard } from '@kmgestao/ui';

import { SuperadminShell } from '../../SuperadminShell.js';
import type { PlanRow } from '../../../../features/plans-admin/index.js';

import { PlanFormDialog } from './PlanFormDialog.js';
import { PlansList } from './PlansList.js';

/**
 * Página Superadmin de gerenciamento de planos em `public.plans`.
 *
 * Fluxo: Lista → botão Novo/Editar abre modal → form valida + chama
 * RPC `admin_upsert_plan` → cache invalidado → lista atualiza. Arquivar
 * é soft delete (`is_active=false, is_public=false`) pra não quebrar
 * FKs em proposals/subscriptions.
 *
 * Protegida por <RequireSuperadmin> no App.tsx. RLS no banco
 * (`plans_superadmin_select` na migration 0055) é o guard final —
 * usuário sem claim is_superadmin não vê planos arquivados mesmo se
 * chegar aqui por engano. */
export function SuperadminPlansPage() {
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState<PlanRow | null>(null);

  const handleAdd = () => {
    setEditing(null);
    setFormOpen(true);
  };
  const handleEdit = (plan: PlanRow) => {
    setEditing(plan);
    setFormOpen(true);
  };

  return (
    <SuperadminShell>
      <PageContainer>
        <PageIntroCard
          eyebrow="Billing · Planos"
          title="Planos da plataforma"
          description="Cadastro base dos planos oferecidos (Free, Pro, Enterprise, ou personalizados). Alterações valem imediatamente para novas propostas. Propostas e assinaturas já emitidas continuam apontando pro plano antigo até serem reemitidas."
        />

        <PlansList onAdd={handleAdd} onEdit={handleEdit} />
      </PageContainer>

      <PlanFormDialog open={formOpen} onOpenChange={setFormOpen} editing={editing} />
    </SuperadminShell>
  );
}
